import { isPriceTestingEnabledCookieSet } from "@/react/utils/isCookieSet";
import { useExperimentEnabled } from "./useExperimentEnabled";

const PROFESSIONAL_PRICE_TESTING_FLAG_NAME = "professional_price_test";
const BUSINESS_PRICE_TEST_FLAG_NAME = "business_price_test";

export const usePriceTestingEnabled = () => {
  const isProfessionalPriceTestEnabled = useExperimentEnabled(
    PROFESSIONAL_PRICE_TESTING_FLAG_NAME,
  );
  const isBusinessPriceTestEnabled = useExperimentEnabled(
    BUSINESS_PRICE_TEST_FLAG_NAME,
  );

  return (
    isProfessionalPriceTestEnabled ||
    isBusinessPriceTestEnabled ||
    isPriceTestingEnabledCookieSet()
  );
};
